var _g, _line, _line2, _line3, _line4, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVidscreen2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "39 268 600 280",
    enableBackground: "new 0 290 700 120",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFB92E",
    strokeWidth: 5.255,
    d: "M186.364,342.393v-52.806c0,0,0-13.663-13.663-13.663H91.773 c0,0-13.663,0-13.663,13.663v39.143c0,0,0,13.663-13.663,13.663H44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF367D",
    strokeWidth: 5.255,
    d: "M402.978,342.393v-52.806c0,0,0-13.663-13.663-13.663h-80.928 c0,0-13.663,0-13.663,13.663v52.806"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8FBE20",
    strokeWidth: 5.255,
    d: "M656,342.393h-22.853c0,0-13.663,0-13.663-13.663v-39.143 c0,0,0-13.663-13.662-13.663h-80.929c0,0-13.663,0-13.663,13.663v52.806"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF6225",
    strokeWidth: 5.255,
    d: "M294.618,356.903v52.806c0,0,0,13.663-13.663,13.663h-80.928 c0,0-13.663,0-13.663-13.663v-52.806"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2178FA",
    strokeWidth: 5.255,
    d: "M511.231,356.903v52.806c0,0,0,13.663-13.663,13.663H416.64 c0,0-13.662,0-13.662-13.663v-52.806"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A6A8AB",
    strokeWidth: 1.5,
    x1: 186.364,
    y1: 342.189,
    x2: 186.364,
    y2: 356.903
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A6A8AB",
    strokeWidth: 1.5,
    x1: 294.513,
    y1: 342.189,
    x2: 294.513,
    y2: 356.903
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A6A8AB",
    strokeWidth: 1.5,
    x1: 511.021,
    y1: 342.189,
    x2: 511.021,
    y2: 356.903
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A6A8AB",
    strokeWidth: 1.5,
    x1: 402.978,
    y1: 342.189,
    x2: 402.978,
    y2: 356.903
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AB",
    d: "M186.364,351.911c1.306,0,2.365-1.059,2.365-2.365c0-1.306-1.059-2.365-2.365-2.365 c-1.306,0-2.365,1.06-2.365,2.365C183.999,350.853,185.058,351.911,186.364,351.911"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AB",
    d: "M294.513,351.911c1.306,0,2.365-1.059,2.365-2.365c0-1.306-1.059-2.365-2.365-2.365 c-1.306,0-2.365,1.06-2.365,2.365C292.148,350.853,293.207,351.911,294.513,351.911"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AB",
    d: "M511.021,351.911c1.307,0,2.365-1.059,2.365-2.365c0-1.306-1.059-2.365-2.365-2.365 c-1.306,0-2.364,1.06-2.364,2.365C508.656,350.853,509.715,351.911,511.021,351.911"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AB",
    d: "M402.978,351.911c1.306,0,2.364-1.059,2.364-2.365c0-1.306-1.059-2.365-2.364-2.365 c-1.307,0-2.365,1.06-2.365,2.365C400.612,350.853,401.671,351.911,402.978,351.911"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidscreen2);
export default __webpack_public_path__ + "static/media/vidscreen2.d5f9ba1825b895448eaaa190a40ca744.svg";
export { ForwardRef as ReactComponent };